/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import Box from "components/generals/Box";
import PayerTable from "components/tables/PayerTable";
import { CoreAPI_URLs } from "constants/http.const";
import useHttp from "hooks/http.hook";
import { useResetPageOnFilter } from "hooks/tableReset.hook";
import { PayerInterface, QueryResultInterface } from "@malmur-technologies/medicalsystem-shared";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useSort from "hooks/useSort.hook";

/**
 * Content component for displaying and managing insurance payers.
 * Provides a table view of all payers (insurance companies) with search,
 * filtering, and pagination functionality.
 * @returns {React.ReactElement} The payer data content component
 */
const PayerDataContent: React.FC = () => {
  const [isLoading, _error, sendRequest] = useHttp();
  const [payerList, setPayerList] = useState<PayerInterface[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageTotal, setPageTotal] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowsTotal, setRowsTotal] = useState<number>(0);
  const { t } = useTranslation();
  const [filterModel, setFilterModel] = useState<string>("");
  const { sortBy, sortOrder, handleSortChange, buildSortParam } = useSort();
  useEffect(() => {
    const nameParam = filterModel ? `name=${filterModel}&` : "";
    const url = `${CoreAPI_URLs.PAYER_GET_ALL}?${nameParam}${buildSortParam()}page=${page}&pageSize=${pageSize}`;

    sendRequest(url, onGetPayerHandler, "GET");
  }, [page, pageSize, filterModel, buildSortParam]);

  useResetPageOnFilter(filterModel, page, setPage);
  
  const onGetPayerHandler = (payersResponse: QueryResultInterface<PayerInterface>) => {
    setPayerList(payersResponse.results);
    setRowsTotal(payersResponse.total);
    setPageTotal(Math.ceil(payersResponse.total / pageSize));
  };

  return (
    <Box>
      <PayerTable
        modelList={payerList}
        setModelList={setPayerList}
        canSearchPlaceholder={t("payerTable.searchPayer")}
        entriesPerPage={{ defaultValue: pageSize }}
        setPageState={setPage}
        setPageSizeState={setPageSize}
        apiPagination={true}
        apiPageTotal={pageTotal}
        apiRowsTotal={rowsTotal}
        apiPageCurrentIndex={page}
        setModelFilter={setFilterModel}
        isLoading={isLoading}
        onSortChange={handleSortChange}
        currentSortBy={sortBy}
        currentSortOrder={sortOrder}
      />
    </Box>
  );
};

export default PayerDataContent;